import { amplitudeEventLogger } from '@collectivehealth/frontend-analytics';
export {
  amplitudeCategories as eventCategories
} from '@collectivehealth/frontend-analytics';

export function logEvent(eventName, properties) {
  amplitudeEventLogger(eventName, properties);
}
